export default __webpack_public_path__ + "static/media/sign-placeholder-en.7265cfcd.png";